import Utils from 'common/utils'
import Constants from 'common/constants'
import DataSource from 'common/dataStore'

const LOG_PREFIX = "[fcm-token] "
class DeviceTokenManager {

    static fetchToken() {
        console.log(LOG_PREFIX, "Fetching fcmToken from the store")

        if (Utils.isNull(DataSource)) {
            return null
        }

        try {
            return DataSource.getItem(Constants.FCM_STORE.DEVICE_TOKEN)
        } catch (e) {
            console.log(LOG_PREFIX, "Error fetching stored fcm token - ", e)
        }
        return null
    }

    static storeToken(tokenDetails) {
        if (Utils.isNull(tokenDetails) || Utils.isNull(DataSource)) {
            return false
        }

        try {
            DataSource.setItem(Constants.FCM_STORE.DEVICE_TOKEN, tokenDetails)
            return true
        } catch (e) {
            console.log(LOG_PREFIX, "Error storing FCMToken, deviceId - ", JSON.stringify(tokenDetails))
        }
        return false
    }

    static storeFeatureFlagForPremiumUser(info) {
        if (Utils.isNull(info) || Utils.isNull(DataSource)) {
            return false
        }
        try {
            DataSource.setItem(Constants.FCM_STORE.SHOW_PREMIUM_FEATURE, info)
            return true
        } catch (e) {
            console.log(LOG_PREFIX, "Error storing SHOW_PREMIUM_FEATURE - ")
        }
        return false
    }

    static getFeatureFlagForPremiumUser() {
        if (Utils.isNull(DataSource)) {
            return false
        }

        try {
            DataSource.getItem(Constants.FCM_STORE.SHOW_PREMIUM_FEATURE)
            return true
        } catch (e) {
            console.log(LOG_PREFIX, "Error storing SHOW_PREMIUM_FEATURE - ")
        }
        return false
    }
}

export default DeviceTokenManager



// WEBPACK FOOTER //
// ./src/manager/deviceTokenManager.js